// src/components/Stats.jsx
import { useEffect, useState } from 'react';
import { FiCoffee, FiUsers } from 'react-icons/fi';
import styled from 'styled-components';
import backgroundImage from '../images/pexels-marta-dzedyshko-1042863-2067431.jpg';

const Stats = () => {
  const [counters, setCounters] = useState([
    { id: 1, target: 200, current: 0, text: "المنتجات المحبوبه", icon: <FiCoffee /> },
    { id: 2, target: 500, current: 0, text: "العملاء الراضون", icon: <FiUsers /> },
  ]);

  useEffect(() => {
    const duration = 2000; // Animation duration in ms
    const increment = 20; // Refresh rate in ms
    const steps = duration / increment;
    
    const interval = setInterval(() => {
      setCounters(prevCounters => 
        prevCounters.map(counter => {
          const step = Math.ceil(counter.target / steps);
          return {
            ...counter,
            current: 
              counter.current + step > counter.target 
                ? counter.target 
                : counter.current + step
          };
        })
      );
    }, increment);

    return () => clearInterval(interval);
  }, []);

  return (
    <StatsSection className='mb-5'>
      <StatsContainer>
        {counters.map((stat) => (
          <StatItem key={stat.id}>
            <StatIcon>{stat.icon}</StatIcon>
            <StatNumber>
              {stat.current}+
            </StatNumber>
            <StatText>{stat.text}</StatText>
          </StatItem>
        ))}
      </StatsContainer>
    </StatsSection>
  );
};

// Styled Components
const StatsSection = styled.section`
  padding: 4rem 1rem;
  color: white;
  position: relative;
  background-image: url(${backgroundImage});
  background-attachment: fixed;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width:90%;
  margin:auto
`;

const StatsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  text-align: center;
`;

const StatItem = styled.div`
  padding: 2rem;
  border-radius: 8px;
  background-color: rgb(0 0 0 / 50%);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const StatIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #c57b57;
`;

const StatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  background: linear-gradient(to right, #c57b57, #e3a27a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const StatText = styled.p`
  font-size: 1.8rem;
  font-weight : 600;
  opacity: 0.9;
  font-family: "Beiruti", sans-serif;
`;

export default Stats;